import { StrictMode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from 'react-oidc-context';

import App from '@/app';
import { SIGNIN_REDIRECT_URL_KEY, userManagerSettings } from '@/features/auth/config/oidc';
import { userManager } from '@/features/auth/services/oidc';
import LoadingPage from '@/pages/loading';

const Root = () => {
  const { t } = useTranslation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleSigninCallback = () => {
    const redirectUrl = window.sessionStorage.getItem(SIGNIN_REDIRECT_URL_KEY);

    if (redirectUrl) {
      window.sessionStorage.removeItem(SIGNIN_REDIRECT_URL_KEY);
      window.location.replace(redirectUrl);

      setIsRedirecting(true);
    } else {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  };

  return (
    <StrictMode>
      <AuthProvider {...userManagerSettings} userManager={userManager} onSigninCallback={handleSigninCallback}>
        {isRedirecting ? (
          <LoadingPage>
            <p>{t('redirecting')}</p>
          </LoadingPage>
        ) : (
          <App />
        )}
      </AuthProvider>
    </StrictMode>
  );
};
Root.displayName = 'Root';

export default Root;
